import { z } from 'zod';
/**
 * autodev_estimate_v1 — pre-flight cost prediction produced by the estimator
 * profile before AutoDev develops an issue (roadmap #55).
 *
 * The estimator LLM is asked to read an issue's title/description/acceptance
 * criteria plus optional roadmap+atlas context and predict:
 *
 *   - tokens   — total Anthropic tokens (prompt + completion across the dev
 *                tool loop, ~15 rounds in practice)
 *   - minutes  — wall-clock minutes from "Dev başlat" to PR-ready
 *   - confidence — model's self-assessed certainty
 *   - reasoning — short Turkish rationale shown to the user
 *
 * The validator (`packages/api/src/modules/autodev/estimator/validator.ts`)
 * parses raw LLM output into this object and clamps absurd values.
 */
export const autodevEstimateConfidenceSchema = z.enum(['low', 'medium', 'high']);
export const autodevEstimateV1Schema = z.object({
    tokens: z.number().int().positive(),
    minutes: z.number().int().positive(),
    confidence: autodevEstimateConfidenceSchema,
    reasoning: z.string().min(1).max(2000),
    schema_version: z.literal('autodev_estimate_v1'),
});
//# sourceMappingURL=autodevEstimate.schema.js.map